<template>
    <div class="row">
        <div class="col-12">
            <p class="offset-2 col-8 blackColor mt-4 mb-5 text-left"><strong>
                You will hear a question. Please give a simple and short answer. Often just one or a few words is enough.
                </strong></p>
            <app-CustomPlayer v-if="audioOn" :noBeep='noBeep'  class="mt-5" ref="customPlayer" :weightTime='playerWeight' :audioSrc='selectedquestion.short_recording'/>
            <app-CurtomRecorder v-else class="mt-5" ref="customRecorder" :noBeep='noBeep' :convert="converSpeech"  :weightTime="weightTime"  :totalduration="totalDuration"/>
        </div>
    </div>
</template>
<script>
import CurtomRecorder from '../../reuseable/customRecorderSlider'
import CustomPlayer from '../../reuseable/customAudioPlayerSlider'
const sdk = require("microsoft-cognitiveservices-speech-sdk");
import { mapActions,mapGetters } from 'vuex'
export default {
    components:{
        'app-CurtomRecorder':CurtomRecorder,
        'app-CustomPlayer':CustomPlayer
    },
    props:{
        currentQuestion:{
            required:true,
            default:null,
        },
        mockId:{
            required:true,
            default:0
        }
    },
    data(){
        return{
            selectedquestion:this.currentQuestion,
            weightTime:0,
            recordSrc:null,
            totalDuration:30,
            playerWeight:3,
            audioOn:true,
            count:0,
            converSpeech:true,
            noBeep:true,
            fileName:'',
            userAnswer:{
                user_id:0,
                short_question_id:0,
                user_recording:null,
                transcript:'',
                mock_test_id:this.mockId
            },
        }
    },
    methods:{
        ...mapActions({
            saveAnswer: 'speakmodule/saveAnswer',
            getTranscripty:'speakmodule/getTranscripty',
            generateFileUpload:'speakmodule/generateFileUpload',
        }),
        ...mapGetters({
            answerResponse: 'speakmodule/AnswerResponse'
        }),
        changePresentQuestion(question){
            this.audioOn=true
            // this.$parent.$parent.disableButton()
            this.selectedquestion = question
            this.fileName='UserShortAnswer--u'+this.userAnswer.user_id+'_q'+this.selectedquestion.question_id+"_track"+Date.now()+'.wav'
            this.userAnswer.transcript=this.selectedquestion.transcript
            //this.fromMic()
            this.$nextTick(function () {
                this.$refs.customPlayer.changeAudio(this.playerWeight,this.selectedquestion.short_recording)
            })
        },
        moveToNextRA(){
            if(!this.audioOn)
            {
                 this.count++
                this.$nextTick(function () {
                this.$refs.customRecorder.stop();
                 this.saveUserAnswer()
                })
            }
            //await this.$refs.customRecorder.changeTiming(this.weightTime,this.totalDuration)
        },
        audioFinish(){
            this.audioOn = false
            // this.$parent.$parent.disableButton()
            if(this.count>0)
            {
                this.$nextTick(function () {
                this.$refs.customRecorder.changeTiming(this.weightTime,this.totalDuration)
                })
            }
            
        },
        saveUserAnswer(){
             //this.userAnswer.transcript=this.selectedquestion.transcript
             var file = new File([this.recordSrc], this.fileName);
            var fd = new FormData()
            fd.append('files', file,this.fileName)
            const filePath='audio/UserShortAnswer/'+this.fileName.replace('--','')
             this.userAnswer.user_recording = filePath
             this.userAnswer.short_question_id=this.selectedquestion.question_id
             this.generateFileUpload(fd).then(()=>{
                 if(this.answerResponse()=="Success"){
                     this.userAnswer.url='usershortanswer/createshortanswer'
                    this.saveAnswer(this.userAnswer).then(()=>{
                            //console.log(this.answerResponse().data)
                        })
                 }

             });
        },
        fromMic() {
            //console.log('In Mic')
            const speechConfig = sdk.SpeechConfig.fromSubscription(process.env.VUE_APP_MICRO_API, process.env.VUE_APP_MICRO_SERVICEREGION);
            let audioConfig = sdk.AudioConfig.fromDefaultMicrophoneInput();
            speechConfig.setProperty(sdk.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs, "2000");
            this.recognizer = new sdk.SpeechRecognizer(speechConfig, audioConfig);
            const phraseList = sdk.PhraseListGrammar.fromRecognizer(this.recognizer);
            phraseList.addPhrase(this.selectedquestion.transcript);
            //console.log('Speak into your microphone.');


            this.recognizer.startContinuousRecognitionAsync();

            this.recognizer.recognizing = (s, e) => {
                if(e!=null)
                {
                        // this.$parent.moveToNextMK()
                        //this.$parent.$parent.next()
                        //console.log("NOMATCH: Speech could not be recognized.");
                        this.recognizer.stopContinuousRecognitionAsync();
                }
            };

            this.recognizer.recognized = (s, e) => {
                ////console.log(e.result)
                    if (e.result.reason == 3) {
                     this.userAnswer.transcript +=e.result.text;
                        //console.log(`RECOGNIZED final: Text=${e.result.text}`);
                    }
                    else if (e.result.reason == 0) {
                        //console.log("NOMATCH: Speech could not be recognized.");
                    }
            };

            this.recognizer.canceled = (s, e) => {
                //console.log(`CANCELED: Reason=${e.reason}`);

                if (e.reason == 0) {
                    //console.log(`"CANCELED: ErrorCode=${e.errorCode}`);
                    //console.log(`"CANCELED: ErrorDetails=${e.errorDetails}`);
                    //console.log("CANCELED: Did you update the subscription info?");
                }

                this.recognizer.stopContinuousRecognitionAsync();
            };

            this.recognizer.sessionStopped = () => {
                ////console.log(s+e)
                //console.log("\n    Session stopped event.");
                this.recognizer.stopContinuousRecognitionAsync();
            };
            
        }
    },
    created(){
        this.userAnswer.user_id=this.$ls.get('user').user_id
        this.userAnswer.transcript=this.selectedquestion.transcript
        this.fileName='UserShortAnswer--u'+this.userAnswer.user_id+'_q'+this.selectedquestion.question_id+"_track"+Date.now()+'.wav'
    }
}
</script>
<style scoped>

.questdesc
{
  border: none!important;
  line-height: 1.8rem;
  position: relative;
  overflow-wrap: break-word;
  word-break: normal;
  background-color: white!important;
}
</style>